import { CURRENCIES, isCurrency } from '@budget/core';
import { useCurrency } from './currency-context.js';

export function CurrencySwitcher() {
  const { displayCurrency, setDisplayCurrency, fxStatus } = useCurrency();

  return (
    <div className="currency-switcher">
      <label className="currency-switcher__label" htmlFor="display-currency">
        Deviza
      </label>
      <select
        id="display-currency"
        className="currency-switcher__select"
        value={displayCurrency}
        onChange={(event) => {
          const next = event.target.value;
          if (isCurrency(next)) setDisplayCurrency(next);
        }}
        data-testid="currency-switcher"
      >
        {CURRENCIES.map((currency) => (
          <option key={currency} value={currency}>
            {currency}
          </option>
        ))}
      </select>
      {fxStatus === 'error' ? (
        <span className="currency-switcher__warning" title="Nem sikerült betölteni az árfolyamokat">
          !
        </span>
      ) : null}
    </div>
  );
}
